import { create } from 'zustand';

const useGlobalStore = create((set) => ({
  // --- State ---
  isToggled: false,
  globalString: "Initial Value",
  isElectron: false,
  isDesktop: false,
  isSmallMobile: false,
  audioQrCode: "",

  // custom ids for things that dont have ids (for urls)
  exhibitionInfoId: 'ex-01',
  visitExhibitionQRId: 'qr-01',
  exhibitionTitle: '',

  // --- Actions ---
  // Action to toggle the boolean
  toggle: () => set((state) => ({ isToggled: !state.isToggled })),
  setElectron: (value) => set({ isElectron: value }),
  setDesktop: (value) => set({ isDesktop: value }),
  setSmallMobile: (value) => set({ isSmallMobile: value }), // not using
  setAudioQrCode: (value) => set({ audioQrCode: value }),
  setExhibitionTitle: (value) => set({ exhibitionTitle: value }),
  

  // Add new state for screensaver
  showScreensaver: false,
  screensaverTitle: 'New exhibition coming soon',
  screensaverSubheading: 'Opening November 2025',
  setShowScreensaver: (value) => set({ showScreensaver: value }),
  disableTouchScreensaver: false,
  setDisableTouchScreensaver: (value) => set({ disableTouchScreensaver: value }),
  setDisableTouchScreensaverTexts: (title, sub) => set({ screensaverTitle: title, screensaverSubheading:sub }),
  

  // Action to set the string value
  setStringValue: (newValue) => set({ globalString: newValue }),
}));

export default useGlobalStore;
